import css from "standard/css";

const style = css`
  .students {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-sm);
  }

  .students__ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-xs);
    list-style-type: none;
  }

  .students__li {
    padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
    justify-content: center;
    border: 1px solid var(--color-master-light);
    border-radius: var(--border-radius-sm);
    width: 100%;
    gap: var(--spacing_inset-nano);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .students__informations {
    gap: var(--spacing_inset-nano);
    display: flex;
    flex-direction: column;
  }

  .students__name {
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    color: var(--color-master-dark);
  }

  .students__email {
    font-family: var(--font-family-base);
    font-size: var(--font-size-nano);
    font-weight: var(--font-weight-regular);
    color: var(--color-master);
  }

  .students__actions {
    display: flex;
    gap: var(--spacing_inset-xs);
  }

  .students__deleteButton,
  .students__changeButton {
    align-items: center;
    position: relative;
    background-color: transparent;
    display: flex;
    justify-content: center;
    border: none;
    cursor: pointer;
    height: 42px;
    width: 42px;
  }

  .students__changePassword {
    color: black;
  }

  .students__delete {
    width: 16px;
    height: 16px;
  }

  .students__deleteButton::before,
  .students__changeButton::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    height: 42px;
    top: 0;
    width: 42px;
  }

  .notFound {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .notFound__title {
    align-items: center;
    color: var(--color-master);
    display: inline-flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-lg);
    text-align: inherit;
    text-transform: inherit;
  }

  .notFound__description {
    align-items: center;
    color: var(--color-master);
    display: inline-flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-lg);
    text-align: inherit;
    text-transform: inherit;
  }
`;

export default style;
